import React from 'react';
// @ts-ignore
import variables from 'styles/_variables.scss';
import { IIconProps } from './IIconProps';

export const CalendarIcon = ({ iconClass = '', title = '' }: IIconProps) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			className={iconClass}
			fill="none"
		>
			{title && <title>{title}</title>}
			<rect
				x="4.5"
				y="5.73083"
				width="15"
				height="13.7692"
				rx="1.5"
				stroke={variables.bgIcon}
			/>
			<rect
				x="12.5"
				y="13.1154"
				width="4.33333"
				height="3.92308"
				stroke={variables.bgIcon}
			/>
			<line
				x1="4"
				y1="7.94434"
				x2="20"
				y2="7.94434"
				stroke={variables.bgIcon}
			/>
			<path
				d="M14.667 4V3.5C14.3908 3.5 14.167 3.72386 14.167 4H14.667ZM16.667 4H17.167C17.167 3.72386 16.9431 3.5 16.667 3.5V4ZM14.667 4.5H16.667V3.5H14.667V4.5ZM16.167 4V5.23077H17.167V4H16.167ZM15.167 5.23077V4H14.167V5.23077H15.167Z"
				fill={variables.bgIcon}
			/>
			<path
				d="M7.33301 4V3.5C7.05687 3.5 6.83301 3.72386 6.83301 4H7.33301ZM9.33301 4H9.83301C9.83301 3.72386 9.60915 3.5 9.33301 3.5V4ZM7.33301 4.5H9.33301V3.5H7.33301V4.5ZM8.83301 4V5.23077H9.83301V4H8.83301ZM7.83301 5.23077V4H6.83301V5.23077H7.83301Z"
				fill={variables.bgIcon}
			/>
		</svg>
	);
};
